var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBackAndFront = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.924 12.46-1.12-1.12.84-.84.616-.532-.014-.056-1.12.056H3.33V8.26h5.796l1.12.056.014-.056-.616-.532-.84-.84 1.12-1.12 3.346 3.346-3.346 3.346Zm-5.848-.92 1.12 1.12-.84.84-.616.532.014.056 1.12-.056h5.796v1.708H4.874l-1.12-.056-.014.056.616.532.84.84-1.12 1.12L.73 14.886l3.346-3.346Z",
    opacity: 0.5,
    fill: "#161616"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgBackAndFront);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back-and-front.52e81a12b90834445708837f1abad303.svg";